import { createStyles } from 'antd-style';

const useStyles = createStyles(() => {
  return {
    'ql-snow': {
      width: '58px',
      content: '"Введите URL видео:"',
      lineHeight: '26px',
      marginRight: '8px',
      borderRight: '0px',
      marginLeft: '8px',
      paddingRight: '0px',
    },
    'ql-picker.ql-header': {
      width: '118px',
      content: "'Заголовок 6'",
    },
    'ql-picker-item::before': {
      content: "'14'",
    },
    'ql-picker-label[data-value="1"]::before': {
      content: "'Заголовок 1'",
    },
    'ql-picker-item[data-value="1"]::before': {
      content: "'Заголовок 1'",
    },
    'ql-picker-label[data-value="2"]::before': {
      content: "'Заголовок 2'",
    },
    'ql-picker-item[data-value="2"]::before': {
      content: "'Заголовок 2'",
    },
    'ql-picker-label[data-value="3"]::before': {
      content: "'Заголовок 3'",
    },
    'ql-picker-item[data-value="3"]::before': {
      content: "'Заголовок 3'",
    },
    'ql-picker-label[data-value="4"]::before': {
      content: "'Заголовок 4'",
    },
    'ql-picker-item[data-value="4"]::before': {
      content: "'Заголовок 4'",
    },
    'ql-picker-label[data-value="5"]::before': {
      content: "'Заголовок 5'",
    },
    'ql-picker-item[data-value="5"]::before': {
      content: "'Заголовок 5'",
    },
    'ql-picker-label[data-value="6"]::before': {
      content: "'Заголовок 6'",
    },
    'ql-picker-item[data-value="6"]::before': {
      content: "'Заголовок 6'",
    },
    'ql-picker.ql-size': {
      width: '58px',
      content: "'32'",
    },
    'ql-picker-label::before': {
      content: "'14'",
    },
    'ql-picker-label[data-value=small]::before': {
      content: "'10'",
    },
    'ql-picker-item[data-value=small]::before': {
      content: "'10'",
    },
    'ql-picker-label[data-value=large]::before': {
      content: "'18'",
    },
    'ql-picker-item[data-value=large]::before': {
      content: "'18'",
    },
    'ql-picker-label[data-value=huge]::before': {
      content: "'32'",
    },
    'ql-picker-item[data-value=huge]::before': {
      content: "'32'",
    },
    'ql-tooltip::before': {
      content: '"Посетите URL:"',
      lineHeight: '26px',
      marginRight: '8px',
    },
    'ql-tooltip': {
      borderRight: '1px solid #ccc',
      content: "'Удалить'",
      marginLeft: '8px',
      paddingRight: '8px',
    },
    'a.ql-action::after': {
      borderRight: '0px',
      content: "'Сохранить'",
      marginLeft: '16px',
      paddingRight: '0px',
    },
    'a.ql-remove::before': {
      content: "'Удалить'",
      marginLeft: '8px',
    },
    'ql-tooltip.ql-editing': {
      borderRight: '0px',
      content: "'Сохранить'",
      paddingRight: '0px',
    },
    'ql-tooltip[data-mode=link]::before': {
      content: '"Введите ссылку:"',
    },
    'ql-tooltip[data-mode=formula]::before': {
      content: '"Введите формулу:"',
    },
    'ql-tooltip[data-mode=video]::before': {
      content: '"Введите URL видео:"',
    },
  };
});
export default useStyles;
